import isNil from 'lodash/isNil';
import { useCallback } from 'react';
import { cx } from '@linaria/utils';
import { baseTheme } from 'styles/utils';
import { SliderProps } from '../types';
import { StyledSlider, container, slider, label } from './styles';

export const BaseSlider = ({
  className,
  sliderClassName,
  value,
  withLabels,
  formatLabel = (val: number) => `${val}`,
  onChange,
  primaryColor = baseTheme.light.colors.primary600,
  secondaryColor = baseTheme.light.colors.gray300,
  ...sliderProps
}: SliderProps) => {
  const handleChange = useCallback(
    (_: Event, numValue: number | number[]) => {
      onChange?.(numValue as number & number[]);
    },
    [onChange],
  );

  return (
    <div className={cx(container, className)}>
      {!isNil(value) && Array.isArray(value) && withLabels && <span className={label}>{formatLabel(value[0])}</span>}
      <StyledSlider
        className={cx(slider, sliderClassName)}
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        value={value}
        onChange={handleChange}
        {...sliderProps}
      />
      {!isNil(value) && withLabels && <span className={label}>{formatLabel(Array.isArray(value) ? value[1] : value)}</span>}
    </div>
  );
};
